$(function()
{
	// catch browser autocomplete
	setTimeout(function()
	{
		if($(el('edtEmailQuickCheckout')).length > 0 && $(el('edtEmailQuickCheckout')).val() !== "") {
			$(el('edtEmailQuickCheckout')).trigger('keyup');
		}
	} , 100);

	if(typeof initFBLogin !== "undefined") initFBLogin();
	if (typeof initGoogleLogin !== "undefined") initGoogleLogin();

	// RESETS
	$(el('mainContent')).off('change', '.deliveryDate:visible');
	$(el('mainContent')).off('click', '.pickupPointSelectBtn');
	$(el('mainContainer')).off('click', '#saveDeliveryAddressEmptyFields');

	// BLURS
	var sSelectorString = (bUseValidationServiceForPhoneFields) ? '#frmDeliveryHd input:not([name="inputInvoiceVat"],[name="inputMobileNumber"],[name="edtGoogleAddress"] )':'#frmDeliveryHd input:not([name="inputInvoiceVat"],[name="edtGoogleAddress"])';
	$(el('mainContainer')).on('blur',sSelectorString, function(e)
	{
		setInitValidation($(e.currentTarget));
		validateQuickCheckoutDeliveryAddress($(e.currentTarget).parents('.inputBlock'),false);
	});

	$(el('mainContainer')).on('change','.paymenttype', function()
	{
		$('.control-group').removeClass('activePaymentType');
		$(this).parents('.control-group').addClass('activePaymentType');
	});

	$(el('mainContainer')).on('change','.inputInvoiceRequired', function()
	{
		var bChecked = $(this).prop('checked');
		var oForm    = $(this).parents('form');

		if(bChecked)
		{
			oForm.find('.invoiceAddressWrapper').show();
		}
		else
		{
			oForm.find('.invoiceAddressWrapper').hide();
		}
	});

	$(el('mainContainer')).on('change','#inputPickupPoint input[name="PickupPointRadio"]', function()
	{
		var sPickupPointId = ($(this).data('id'));
		var sShopId = $(this).attr('shopid')
		// set selected
		$('#inputPickupPoint .radio').removeClass('selected');
		$(this).parents('.radio').addClass('selected');

		loadPickupPointData(sPickupPointId);
		setSelectedStateInputPickupPoint(true);

		if(typeof sPickupPointId != "undefined" && sPickupPointId !== "" && typeof sShopId !== "undefined" && sShopId !== "")
		{
			setCollectMethodTransaction($(el("collapsePP")).data('collectmethodId'),sShopId,sPickupPointId);
		}
	});

	$(el('mainContainer')).on('focus','.sortPickupPointsPostalCode', function()
	{
		loadPickupPointData('');
		setSelectedStateInputPickupPoint(false);
	});

	$(el('mainContainer')).on('blur','.sortPickupPointsPostalCode', function()
	{
		setTimeout(function(){
			if ($('#inputPickupPoint').find('input[name="PickupPointRadio"]:checked').length > 0) {
				$('#inputPickupPoint input[name="PickupPointRadio"]:checked').trigger('change');
			}
		 },100);
	});

	$(el('mainContainer')).on('change','#inputCCShop', function()
	{
		var sCCShopId = ($(this).find('option:selected').data('id'));
		loadCCShopData(sCCShopId);

		if(sCCShopId != "")
		{
			setCollectMethodTransaction($(el("collapseCC")).data('collectmethodId'),sCCShopId);
		}
	});

	$(el('mainContainer')).on('change', '.deliveryDate:visible', function() {
		if($(this).val() === '' || isPastDate($('.deliveryDate:visible').datepicker('getDate')))
		{
			setDeliveryDate($(this));
		}
		if (bQuickCheckoutDeliveryDateExtended)
		{
			var oDate           = $(this).datepicker('getDate');
			var iDateDiffInDays = dateDiffInDays(new Date(), oDate);

			if (iDateDiffInDays === 1)
			{
				$('.deliveryDateCustom').val(sQuickCheckoutDeliveryNearDateTomorrow);
			}
			else if (iDateDiffInDays === 2)
			{
				$('.deliveryDateCustom').val(sQuickCheckoutDeliveryNearDateDayAfterTomorrow);
			}
			else
			{
				var sDay = oDate.getDate();
				var sMonth = new Intl.DateTimeFormat(sLocale.replace("_","-"), {month: "long" }).format(oDate);
				var sYear = oDate.getFullYear();

				$('.deliveryDateCustom').val(sDay + " " + sMonth + " " + sYear);
			}
		}
	});

	$(el('mainContainer')).on('change','#quickCheckoutDeliveryHdAddressOther input[type=radio]', function(e)
	{
		var oModal = $(el('quickCheckoutDeliveryHdAddressOther'));
		var sHtml  = $(this).parents('label').find('.addressDataWrapper').html();

		$(el('inputDeliveryAddress')).html(sHtml);
		$(el('inputDeliveryAddressValue')).val($(this).val()).data('postalcode',$(this).data('postalcode')).trigger('change');
		oModal.modal('hide');

		oModal.find('.addressOtherWrapper label').removeClass('selectedRadio');
		oModal.find('.addressOtherWrapper .addressBtnWrapper .btn').removeClass('optionSelected').text(sQuickCheckoutDeliveryHdAddressSelectBtn);
		$(this).parents('label').addClass('selectedRadio');
		$(this).parents('label').find('.addressBtnWrapper .btn').addClass('optionSelected').text(sQuickCheckoutDeliveryHdAddressSelectedBtn);

		validateAddressDefaults();

		// if user was forced to choose a diff country -> switch to normal visually
		if($('.forceNewAddress').length > 0)
		{
			$('.customerAddressNewBtn span').text(sOtherAddress);
			$('.customerAddressNewBtn i').removeClass('fa-exclamation-circle').addClass('fa-pencil');
			$('.forceNewAddress').removeClass('forceNewAddress');
			$(el('inputDeliveryAddress')).removeClass('alert alert-info');
		}
	});

	$(el('mainContainer')).on('change','#quickCheckoutInvoiceAddressOther input[type=radio]', function(e)
	{
		var oModal   = $(el('quickCheckoutInvoiceAddressOther'));
		var sHtml    = $(this).parents('label').find('.addressDataWrapper').html();

		$('.inputInvoiceAddress').html(sHtml);
		$('.inputInvoiceAddressValue').val($(this).val());
		oModal.modal('hide');

		oModal.find('.addressOtherWrapper label').removeClass('selectedRadio');
		oModal.find('.addressOtherWrapper .addressBtnWrapper .btn').removeClass('optionSelected').text(sQuickCheckoutDeliveryHdAddressSelectBtn);
		$(this).parents('label').addClass('selectedRadio');
		$(this).parents('label').find('.addressBtnWrapper .btn').addClass('optionSelected').text(sQuickCheckoutDeliveryHdAddressSelectedBtn);

		$(this).parents('label').find('.addressActions .updateAddressDefaultBtn').trigger('click');
	});

	$(el('mainContainer')).on('change','.inputInvoiceAddressEqualsDeliveryAddress', function(e)
	{
		if(!$(this).is(':checked'))
		{
			$(el('quickCheckoutInvoiceAddressOther')).modal('show');

			if(!$(this).data('extradddress'))
			{
				$(el('createInvoiceAddress')).trigger('click');
			}
		}
		else if(($(el('inputDeliveryAddressValue')).val() !== $('.inputInvoiceAddressValue').val()))
		{
			// set selected delivery address as invoice address
			$('input[name="inputInvoiceAddress"][value="' + $(el('inputDeliveryAddressValue')).val() + '"]').prop('checked', true).trigger('change');
		}
	});

	$(el('mainContainer')).on('change','#inputDeliveryAddressValue', function(e)
	{
		if($(".quickCheckoutCustomHomeDelivery").length > 0)
		{
			var sPostalCode = $(this).data('postalcode');
			setCustomHdDelivery((sQuickCheckoutCustomHdPostalCodes.toString().indexOf(sPostalCode) !== -1) && nTotalAmountSubtotalFull >= iQuickCheckoutCustomHdMinAmount);
		}
	});

	$(el('mainContainer')).on('change','.saleCreditAmountWrapper .amount', function(e)
	{
		var iMaxAmount = parseFloat($(this).data('maxAmount'));
		var iValue     = parseFloat($(this).val());

		if (isNaN(iValue) || iValue < 0 || iValue > iMaxAmount) {
			$(this).val('');
		}
		else if (iValue > 0 && iValue > iMaxAmount) {
			$(this).val(iMaxAmount);
		}
	});

	$(el('mainContainer')).on('keyup','#frmDeliveryHd .inputPostalcode', function(e)
	{
		if($(".quickCheckoutCustomHomeDelivery").length > 0 && $(this).parents('#quickCheckoutDeliveryHdAddressOther').length == 0 && $(this).val().length > 3)
		{
			var sPostalCode = $(this).val();
			setCustomHdDelivery((sQuickCheckoutCustomHdPostalCodes.toString().indexOf(sPostalCode) !== -1) && nTotalAmountSubtotalFull >= iQuickCheckoutCustomHdMinAmount);
		}
	});

	// CLICKS
	$(el('mainContainer')).on('click','.btnQuickCheckoutSubmit', function(e)
	{
		e.preventDefault();

		setSubmitIdentificationBtnDisabled(true, $(this));

		// set password required attr based on bLoginCustomer
		var bLoginCustomer = $(this).attr('logincustomer');
		(bLoginCustomer == "true") ? $("#edtPasswordQuickCheckout").attr('required', 'required') : $("#edtPasswordQuickCheckout").removeAttr('required');

		if(typeof gRecaptchaSiteKey !== "undefined" && gRecaptchaSiteKey && typeof grecaptcha !== "undefined"){
			grecaptcha.ready(function() {
				grecaptcha.execute(gRecaptchaSiteKey, {action: 'login'}).then(function(token) {
					executeIdentify(bLoginCustomer,token);
				});
			});
		}
		else{
			executeIdentify(bLoginCustomer);
		}
	});

	$(el('mainContainer')).on('click','#btnQuickCheckoutForgotPassword', function(e)
	{
		$(el('btnQuickCheckoutForgotPassword')).prop("disabled",true);

		var oFrm       = $(el('frmQuickCheckout'));
		var bValidForm = validateForm(oFrm);

		if (bValidForm)
		{
			sendPasswordReset();
		}
		else
		{
			$(el('btnQuickCheckoutForgotPassword')).prop("disabled",false);
		}
	});

	$(el('mainContainer')).on('click','#submitVoucherOnly', function(e)
	{
		e.preventDefault();
		setSubmitDisabled(true);

		var oForm      = $(el('frmVoucherOnly'));
		var bValidForm = validateQuickCheckoutVoucherOnly(oForm, true);

		if(bValidForm && (!bReturningCustomer || (bReturningCustomer && bLoginCustomer)))
		{
			var oForm = $(el('frmVoucherOnly'));
			var oCall = updateInvoiceAddress(oForm);
			oCall.success(function (oData) {
				if (oData.errorMessage === '') {
					loadQuickCheckoutPayment();
				}
				else if(oData.errorType === 'expired')
				{
					location.reload(true);
				}
				else if(oData.errorType === 'invalidEmail')
				{
					window.location = '/' + sCurrentLanguageCode + '/transaction/checkout';
				}
				else {
					showAlert('error', oData.errorMessage, oData.errorUnhandled);
				}
			});
		}
		else if(bValidForm && bReturningCustomer && !bLoginCustomer)
		{
			loadQuickCheckoutPayment();
		}
	});

	$(el('mainContainer')).on('click','#submitQuickCheckoutDeliveryAddress', function(e)
	{
		e.preventDefault();
		setSubmitDisabled(true);

		var sCollectMethod  = $(this).data('collectMethod');
		submitQuickCheckoutDeliveryAddress('',sCollectMethod);
	});

	$(el('mainContainer')).on('click','.customerAddressNewBtn', function(e)
	{
		e.preventDefault();
		$(el('quickCheckoutDeliveryHdAddressOther')).modal('show');
		centerPopups();
	});

	$(el('mainContainer')).on('click','.editCustomerData', function(e)
	{
		e.preventDefault();
		loadQuickCheckoutDelivery();
	});

	$(el('mainContainer')).on('click','.toggleForgotPasswordBtn', function(e)
	{
		e.preventDefault();
		loadForgotPassword(true);
	});

	$(el('mainContainer')).on('click','.unToggleForgotPasswordBtn', function(e)
	{
		e.preventDefault();
		loadForgotPassword(false);
	});

	$(el('mainContainer')).on('click', '#saveDeliveryAddressEmptyFields', function(e)
	{
		e.preventDefault();

		var bExecuted = false;
		function checkAndWait(){
			if(!bPostalCodeBusy && !bExecuted){
				bExecuted = true;
				var sMissingParams = getValues($(el('deliveryAddressEmptyFields')));
				var sCollectMethod  = $("#saveDeliveryAddressEmptyFields").data('collectMethod');
				submitQuickCheckoutDeliveryAddress(sMissingParams,sCollectMethod);

				$(el('deliveryAddressEmptyFields')).modal('hide');
			}
			else{
				setTimeout(function(){
					checkAndWait();
				},150);
			}
		}
		checkAndWait();
	});

	$(el('mainContainer')).on('click', '#saveCustomerAddressEmptyFields', function(e)
	{
		e.preventDefault();

		var bExecuted = false;
		function checkAndWait(){
			if(!bPostalCodeBusy && !bExecuted){
				bExecuted = true;
				var sMissingCustomerData = getValues($(el('customerAddressEmptyFields')));
				var sCollectMethod  = $("#saveCustomerAddressEmptyFields").data('collectMethod');
				handleQuickCheckoutSendcloudAddressSubmit(sCollectMethod,sMissingCustomerData);

				$(el('deliveryAddressEmptyFields')).modal('hide');
			}
			else{
				setTimeout(function(){
					checkAndWait();
				},150);
			}
		}
		checkAndWait();
	});

	$(el('mainContainer')).on('click', '.pickupPointSelectBtn', function(){
		selectPickupPoint($(this));
	});

	$(el('mainContainer')).on('click', '#submitQuickCheckoutPickupAddress', function(e)
	{
		e.preventDefault();
		setSubmitDisabled(true);

		var oSelectedOption = $('#inputPickupPoint input[name="PickupPointRadio"]:checked');
		var sCollectMethod  = $(this).data('collectMethod');
		if(oSelectedOption.length > 0 && oSelectedOption.data('id') !== '')
		{
			submitQuickCheckoutPickupAddress(oSelectedOption,sCollectMethod);
		}
		else
		{
			inlineAlert('error', sWarningSelectPickup, false, $('.inputPickupPointContainer'));
			setSubmitDisabled(false);
		}
	});

	$(el('mainContainer')).on('click', '#submitQuickCheckoutCCShop', function(e)
	{
		e.preventDefault();
		setSubmitDisabled(true);

		var shopSelect = $('#inputCCShop option:selected');
		var oSelectedOption = shopSelect;
		var sCollectMethodId = $(this).data('collectMethodId');

		if (shopSelect.prop("disabled") == true || oSelectedOption.data('id') == '') {
			inlineAlert('error', sWarningSelectShop, false, $(el('inputCCShop')));
			setSubmitDisabled(false);
		}
		else {
			submitQuickCheckoutCCShop(oSelectedOption,sCollectMethodId);
		}
	});

	$(el('mainContainer')).on('click', '.submitBpostPostalcode', function(e)
	{
		e.preventDefault();

		var sPostalCode = $('.inputBpostPostalcode').val();
		loadNearestBpostAddresses(sPostalCode);
	});

	$(el('mainContainer')).on('click', '.submitSendcloudPostalcode', function(e)
	{
		e.preventDefault();

		var sPostalCode = $('.inputSendcloudPostalcodeSearch').val();
		var sCountryCode = $('.inputSendcloudCountry').val();
		var sCountryDescription = $('.inputSendcloudCountry').find('option:selected').html().trim();

		loadNearestSendcloudAddresses(sPostalCode,sCountryCode,sCountryDescription);
	});

	$(el('mainContainer')).on('click', '.selectNearest', function(e)
	{
		e.preventDefault();

		if(!$(e.target).hasClass('BpostOpeningHours') && !$(e.target).hasClass('closeBpostOpeningHours'))
		{
			var sId = $(this).data('id');
			var sType = $(this).data('type');
			loadBpostAddress(sId,sType,$(this));
		}
	});

	$(el('mainContainer')).on('click', '.selectNearestSendCloudServicePoint', function(e)
	{
		e.preventDefault();

		if(!$(e.target).hasClass('sendCloudOpeningHours'))
		{
			loadSendCloudServicePoint($(this));
		}
	});

	$(el('mainContainer')).on('click', '.BpostOpeningHours', function(e)
	{
		e.preventDefault();
		var oNearest = $(this).parents('.selectNearest');
		var sId = oNearest.data('id');
		var sType = oNearest.data('type');
		loadBpostOpeningHours(sId,sType);
	});

	$(el('mainContainer')).on('click', '.closeBpostOpeningHours', function(e)
	{
		e.preventDefault();
		var oNearest = $(this).parents('.selectNearest');
		setBpostOpeningHours(oNearest,false);
	});

	$(el('mainContainer')).on('click', '#submitQuickCheckoutBpostAddress', function(e)
	{
		e.preventDefault();
		setSubmitDisabled(true);

		if($('.BpostAddressSelected').is(':visible'))
		{
			var oSelectedOption = $('.BpostAddressSelected .BpostAddressSelectedData');
		}
		else
		{
			var oSelectedOption = $('.BpostData .selected');
		}

		if(oSelectedOption.length > 0)
		{
			var sCollectMethod  = $(this).data('collectMethod');
			submitQuickCheckoutBpostAddress(oSelectedOption,sCollectMethod);
		}
		else
		{
			inlineAlert('error', sWarningSelectPickup, false, $('.selectedBpostData'));
			setSubmitDisabled(false);
		}
	});

	$(el('mainContainer')).on('click', '#submitQuickCheckoutSendcloudAddress', function(e)
	{
		e.preventDefault();

		handleQuickCheckoutSendcloudAddressSubmit($(this).data('collectMethod'));
	});

	$(el('mainContainer')).on('click', '.BpostAddressSearchToggle', function(e)
	{
		e.preventDefault();

		$('.BpostAddressSelected').hide();
		$('.BpostAddressSearch').show();
	});

	$(el('mainContainer')).on('click', '.sendcloudAddressSearchToggle', function(e)
	{
		e.preventDefault();

		$('.sendcloudAddressSelected').hide();
		$('.sendcloudAddressSearch').show();
	});

	$(el('mainContainer')).on('click', '.deliveryCountriesInfo', function(e)
	{
		e.preventDefault();

		$(this).popover();
	});

	$(el('mainContainer')).on('click', '#createDeliveryAddress', function(e)
	{
		clearInlineErrors();
		e.preventDefault();

		var oModal        = $(el('quickCheckoutDeliveryHdAddressOther'));
		var oAddressNew   = oModal.find('.addressNewWrapper');
		var oAddressOther = oModal.find('.addressOtherWrapper');

		oAddressNew.show();
		oAddressNew.find('.control-group').removeClass('error success');
		oAddressNew.find("input[type=text]").val("");
		oAddressNew.find("input[type=hidden]").val("");
		oAddressNew.find('.inputMainAddress').val(false);
		oAddressOther.hide();

		oModal.find('.modal-header h2').text(sQuickCheckoutDeliveryHdAddressCreateBtn);
		oModal.find('.modal-header p').hide();

		centerPopups();
	});

	$(el('mainContainer')).on('click', '#createInvoiceAddress', function(e)
	{
		e.preventDefault();

		var oModal        = $(el('quickCheckoutInvoiceAddressOther'));
		var oAddressNew   = oModal.find('.addressNewWrapper');
		var oAddressOther = oModal.find('.addressOtherWrapper');

		oAddressNew.show();
		oAddressNew.find('.control-group').removeClass('error success');
		oAddressNew.find("input[type=text]").val("");
		oAddressNew.find('.inputMainAddress').val(false);
		oAddressOther.hide();

		oModal.find('.modal-header h2').text(sQuickCheckoutDeliveryHdAddressCreateBtn);
		oModal.find('.modal-header p').hide();
	});

	$(el('mainContainer')).on('click', '#cancelCreateDeliveryAddress', function(e)
	{
		e.preventDefault();

		$('.addressOtherWrapper').show();
		$('.addressNewWrapper').hide();

		$(el('quickCheckoutInvoiceAddressOther')).find('.modal-header h2').text(sQuickCheckoutDeliveryHdAddressNewTitle);
		$(el('quickCheckoutInvoiceAddressOther')).find('.modal-header p').show();
		$('.addressOtherWrapper label.radio').removeClass('active');

		centerPopups();
	});

	$(el('mainContainer')).on('click', '#cancelCreateInvoiceAddress', function(e)
	{
		e.preventDefault();

		$('.addressOtherWrapper').show();
		$('.addressNewWrapper').hide();
		$('.addressCustomerWrapper').hide();

		$(el('quickCheckoutDeliveryHdAddressOther')).find('.modal-header h2').text(sQuickCheckoutDeliveryHdAddressNewTitle);
		$(el('quickCheckoutDeliveryHdAddressOther')).find('.modal-header p').show();
		$('.addressOtherWrapper label.radio').removeClass('active');
	});

	$(el('mainContainer')).on('click', '#saveDeliveryAddress', function(e)
	{
		$(this).prop("disabled",true);

		e.preventDefault();

		var bExecuted = false;
		function checkAndWait(){
			if(!bPostalCodeBusy && !bExecuted){
				bExecuted = true;
				var bValidForm = validateForm($('.addressNewWrapper'));

				if(bValidForm)
				{
					// update customer address
					var oCall = createNewAddress($(el('quickCheckoutDeliveryHdAddressOther')).find('.addressNewWrapper'));
					oCall.success(function(oData)
					{
						if(oData.errorType === "")
						{
							var oCall = quickCheckoutAddressList('delivery');
							oCall.success(function(oData)
							{
								if(oData.errorType === "")
								{
									var sId = $(el('quickCheckoutDeliveryHdAddressOther')).find('.addressOtherWrapper > label.radio.active input').val();
									$(el('quickCheckoutDeliveryHdAddressOther')).modal('hide');
									$(el('quickCheckoutDeliveryHdAddressOther')).replaceWith(oData.html);
									$(el('quickCheckoutDeliveryHdAddressOther')).modal('show');
									centerPopups();

									if(typeof sId !== "undefined")
									{
										$(el('quickCheckoutDeliveryHdAddressOther')).find('.addressOtherWrapper input[value="' + sId + '"]').trigger('change').prop("checked", true);
									}
									else
									{
										$(el('quickCheckoutDeliveryHdAddressOther')).find('.addressOtherWrapper label.radio:last-child input').trigger('change').prop("checked", true);
									}

									// also update invoiceaddress output.
									if($(el('inputDeliveryAddressValue')).val() == $('#collapseHD .inputInvoiceAddressValue').val())
									{
										$('#collapseHD .inputInvoiceAddress').html($(el('inputDeliveryAddress')).html());
									}

									// also update invoice address modal.
									var oCall = quickCheckoutAddressList('billing');
									oCall.success(function(oData)
									{
										if(oData.errorType === "")
										{

											var sCollectMethod = $("#submitQuickCheckoutDeliveryAddress").data('collectMethod');
											var oCall = submitQuickCheckoutDeliveryAddress('', sCollectMethod);
											oCall.success(function (oData) {
												$(el('quickCheckoutInvoiceAddressOther')).replaceWith(oData.html);
												var oBasket = $('.quickCheckoutWrapper').find('.quickCheckoutBasket');
												oBasket.html(oData.basketQC);

												validateAddressDefaults();
											});
										}
									});
								}
							});

							$(this).prop("disabled",false);
						}
						else
						{
							inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $('#cancelCreateDeliveryAddress'), false);
							$("#saveDeliveryAddress").prop("disabled",false);
						}
					});
				}
				else
				{
					("#saveDeliveryAddress").prop("disabled",false);
				}
			}
			else{
				setTimeout(function(){
					checkAndWait();
				},150);
			}
		}
		checkAndWait();
	});

	$(el('mainContainer')).on('click', '#saveInvoiceAddress', function(e)
	{
		e.preventDefault();

		var bExecuted = false;
		function checkAndWait(){
			if(!bPostalCodeBusy && !bExecuted){
				bExecuted = true;

				var oQuickCheckoutInvoiceAddressOther = $(el('quickCheckoutInvoiceAddressOther'));
				var bCustomerAddress                  = oQuickCheckoutInvoiceAddressOther.data('mainaddress');
				var oForm                             = (bCustomerAddress) ? oQuickCheckoutInvoiceAddressOther.find('.addressCustomerWrapper') : oQuickCheckoutInvoiceAddressOther.find('.addressNewWrapper');
				var bValidForm                        = validateForm(oForm);

				if(bValidForm)
				{
					if(bCustomerAddress)
					{
						// update t_customer address data
						oCall = updateInvoiceAddress(oForm);
						oCall.success(function(oData)
						{
							if (oData.errorMessage === '')
							{
								var oCall = quickCheckoutAddressList('billing');
								oCall.success(function(oData)
								{
									if(oData.errorType === "")
									{
										var sId = oQuickCheckoutInvoiceAddressOther.find('.addressOtherWrapper > label.radio.active input').val();
										$(el('quickCheckoutInvoiceAddressOther')).modal('hide');
										$(el('quickCheckoutInvoiceAddressOther')).replaceWith(oData.html);
										$(el('quickCheckoutInvoiceAddressOther')).modal('show');
										centerPopups();

										if(typeof sId !== "undefined")
										{
											$(el('quickCheckoutInvoiceAddressOther')).find('.addressOtherWrapper input[value="' + sId + '"]').trigger('change').prop("checked", true);
										}
										else
										{
											$(el('quickCheckoutInvoiceAddressOther')).find('.addressOtherWrapper label.radio:last-child input').trigger('change').prop("checked", true);
										}

										// also update deliveryaddress output.
										if($(el('inputDeliveryAddressValue')).val() == $('#collapseHD .inputInvoiceAddressValue').val())
										{
											$(el('inputDeliveryAddress')).html($('#collapseHD .inputInvoiceAddress').html());
										}

										// also update invoice address modal.
										var oCall = quickCheckoutAddressList('delivery');
										oCall.success(function(oData)
										{
											if(oData.errorType === "")
											{
												$(el('quickCheckoutDeliveryHdAddressOther')).replaceWith(oData.html);

												validateAddressDefaults();
											}
										});
									}
								});
							}
							else if(oData.errorType === 'expired')
							{
								location.reload(true);
							}
							else if(oData.errorType === 'invalidEmail')
							{
								window.location = '/' + sCurrentLanguageCode + '/transaction/checkout';
							}
							else
							{
								showAlert('error', oData.errorMessage, oData.errorUnhandled);
							}
						});
					}
					else
					{
						// update - create t_customer_address
						var oCall = createNewAddress(oForm);
						oCall.success(function(oData)
						{
							if(oData.errorType === "")
							{
								var oCall = quickCheckoutAddressList('billing');
								oCall.success(function(oData)
								{
									if(oData.errorType === "")
									{
										var sId = $(el('quickCheckoutInvoiceAddressOther')).find('.addressOtherWrapper > label.radio.active input').val();
										$(el('quickCheckoutInvoiceAddressOther')).modal('hide');
										$(el('quickCheckoutInvoiceAddressOther')).replaceWith(oData.html);
										$(el('quickCheckoutInvoiceAddressOther')).modal('show');
										centerPopups();

										if(typeof sId !== "undefined")
										{
											// trigger updated address
											$(el('quickCheckoutInvoiceAddressOther')).find('.addressOtherWrapper input[value="' + sId + '"]').trigger('change').prop("checked", true);
										}
										else
										{
											// trigger created address
											$(el('quickCheckoutInvoiceAddressOther')).find('.addressOtherWrapper label.radio:last-child input').trigger('change').prop("checked", true);
										}

										// also update deliveryaddress output.
										if($(el('inputDeliveryAddressValue')).val() == $('#collapseHD .inputInvoiceAddressValue').val())
										{
											$(el('inputDeliveryAddress')).html($('#collapseHD .inputInvoiceAddress').html());
										}

										// also update delivery address modal.
										var oCall = quickCheckoutAddressList('delivery');
										oCall.success(function(oData)
										{
											if(oData.errorType === "")
											{
												$(el('quickCheckoutDeliveryHdAddressOther')).replaceWith(oData.html);

												validateAddressDefaults();
											}
										});
									}
								});
							}
						});
					}
				}
			}
			else{
				setTimeout(function(){
					checkAndWait();
				},150);
			}
		}
		checkAndWait();
	});

	$(el('mainContainer')).on('click', '.updateAddressDefaultBtn', function(e)
	{
		e.preventDefault();

		var oBtn = $(this);
		var sType        = $(this).data('type');
		var sId          = $(this).data('id');
		var bMainAddress = $(this).data('mainaddress');

		var oCall = updateAddressDefault(sType,sId,bMainAddress);
		oCall.success(function(oData)
		{
			if(oData.errorType === "")
			{
				var oCall = quickCheckoutAddressList(sType);
				oCall.success(function(oData)
				{
					if(oData.errorType === "")
					{
						if(sType === 'billing')
						{

							$(el('quickCheckoutInvoiceAddressOther')).modal('hide');
							$(el('quickCheckoutInvoiceAddressOther')).replaceWith(oData.html);
							$(el('quickCheckoutInvoiceAddressOther')).modal('show');
							centerPopups();

							$(el('quickCheckoutInvoiceAddressOther')).find('.addressOtherWrapper input[value="' + sId + '"]').trigger('change').prop("checked", true);

							if(typeof oData.defaultBillingCountryId !== "undefined" && oData.defaultBillingCountryId !== "")
							{
								$('.inputCountry[name="inputInvoiceCountry"]').val(oData.defaultBillingCountryId).change();
							}
						}
						else
						{
							$(el('quickCheckoutDeliveryHdAddressOther')).modal('hide');
							$(el('quickCheckoutDeliveryHdAddressOther')).replaceWith(oData.html);
							$(el('quickCheckoutDeliveryHdAddressOther')).modal('show');
							centerPopups();

							$(el('quickCheckoutDeliveryHdAddressOther')).find('.addressOtherWrapper input[value="' + sId + '"]').trigger('change').prop("checked", true);
						}

						validateAddressDefaults();
					}
				});
			}
		});
	});

	$(el('mainContainer')).on('click', '.editAddressBtn', function(e)
	{
		clearInlineErrors();
		e.preventDefault();

		var oModal = $(this).parents('.modal');

		oModal.find('.addressOtherWrapper').hide();

		var oAddressNewWrapper = oModal.find('.addressNewWrapper');


		oAddressNewWrapper.show();

		oAddressNewWrapper.find('.inputCountry').val($(this).data('country')).change();
		oAddressNewWrapper.find('.control-group').removeClass('error success');
		oAddressNewWrapper.find('.inputAddressId').val($(this).data('id'));
		oAddressNewWrapper.find('.inputStreet').val($(this).data('address'));
		oAddressNewWrapper.find('.inputHousenumber').val($(this).data('housenumber'));
		oAddressNewWrapper.find('.inputBox').val($(this).data('box'));
		oAddressNewWrapper.find('.inputPostalcode').val($(this).data('postalcode'));
		oAddressNewWrapper.find('.inputCity').val($(this).data('city'));
		oAddressNewWrapper.find('.inputMainAddress').val($(this).data('mainaddress'));
		oAddressNewWrapper.find('.inputCompany').val($(this).data('company'));
		oAddressNewWrapper.find('.inputFirstName').val($(this).data('firstname'));
		oAddressNewWrapper.find('.inputLastName').val($(this).data('lastname'));

		oModal.find('.modal-header h2').text(sQuickCheckoutDeliveryHdAddressEdit);
		oModal.find('.modal-header p').hide();
		oModal.data('mainaddress',$(this).data('mainaddress'));

		$(this).parents('label.radio').addClass('active');

		centerPopups();
	});

	$(el('mainContainer')).on('change', '.smartAddressFields select.inputCountry', function(e)
	{
		var oAddressNewWrapper = $(this).closest('.smartAddressFields');
		oAddressNewWrapper.find('.addressLocations').addClass('hidden');
		var selectedCountryCode = oAddressNewWrapper.find('select.inputCountry option:selected').data('code');
		switch(selectedCountryCode){
			case 'NL':
				oAddressNewWrapper.find('.addressLocationNL').removeClass('hidden');
				break;
			default:
				oAddressNewWrapper.find('.addressLocationDefault').removeClass('hidden');
				break;
		}
	});

	$(el('mainContainer')).on('click', '.editCustomerAddressBtn', function(e)
	{
		e.preventDefault();

		var oModal = $(this).parents('.modal');

		oModal.find('.addressOtherWrapper').hide();

		var oAddressNewWrapper = oModal.find('.addressCustomerWrapper');
		oAddressNewWrapper.show();
		oAddressNewWrapper.find('.inputCountry').val($(this).data('country')).change();
		oAddressNewWrapper.find('.control-group').removeClass('error success');
		oAddressNewWrapper.find('.inputAddressId').val($(this).data('id'));
		oAddressNewWrapper.find('.inputStreet').val($(this).data('address'));
		oAddressNewWrapper.find('.inputHousenumber').val($(this).data('housenumber'));
		oAddressNewWrapper.find('.inputBox').val($(this).data('box'));
		oAddressNewWrapper.find('.inputPostalcode').val($(this).data('postalcode'));
		oAddressNewWrapper.find('.inputCity').val($(this).data('city'));
		oAddressNewWrapper.find('.inputMainAddress').val($(this).data('mainaddress'));
		oAddressNewWrapper.find('.inputCompany').val($(this).data('company'));
		oAddressNewWrapper.find('.inputFirstName').val($(this).data('firstname'));
		oAddressNewWrapper.find('.inputLastName').val($(this).data('lastname'));

		oModal.find('.modal-header h2').text(sQuickCheckoutDeliveryHdAddressEdit);
		oModal.find('.modal-header p').hide();
		oModal.data('mainaddress',$(this).data('mainaddress'));

		$(this).parents('label.radio').addClass('active');
	});

	$(el('mainContainer')).on('click','.customerInvoiceAddressNewBtn', function(e)
	{
		e.preventDefault();

		$(el('quickCheckoutInvoiceAddressOther')).modal('show');

		centerPopups();
	});

	// KEYUPS
	$(el('mainContainer')).on('keyup','#edtEmailQuickCheckout', function()
	{
		if($(this).data('initValidation') === true)
		{
			var bValidEmail = validateQuickCheckoutEmail();
			if(bValidEmail)
			{
				var oCall = checkEmail($(this).val());
				oCall.success(function(oData)
				{
					handleCheckEmail(oData);
				});
			}
		}
	});

	$(el('mainContainer')).on('keyup','#edtPasswordQuickCheckout', function()
	{
		validateQuickCheckoutEmail();
	});

	var sSelectorString = (bUseValidationServiceForPhoneFields) ? '#frmDeliveryHd input:not(.inputInvoiceVat,.inputVat,.inputMobileNumber)':'#frmDeliveryHd input:not(.inputInvoiceVat,.inputVat)';
	$(el('mainContainer')).on('keyup',sSelectorString, function(e)
	{
		if($(e.currentTarget).data('initValidation') === true)
		{
			validateQuickCheckoutDeliveryAddress($(e.currentTarget).parents('.inputBlock'),false);
		}
	});

	if(bUseValidationServiceForPhoneFields)
	{
		$(el('mainContainer')).off('keyup','#frmDeliveryHd .inputMobileNumber');
	}

	$(el('mainContainer')).on('change keyup', '#edtVoucher', function(e)
	{
		var sInput = $(el('edtVoucher')).val().toLowerCase().replace(/\s/g,'');
		if(sInput.length > 1)
		{
			// Check if code starts with voucher prething
			var aListVoucher = ["gft","loy","cv","vrn","0000"];
			matched = false;
			for(i=0; i<= aListVoucher.length; i++)
			{
				if(sTenantId === 175 && (sInput === "0000000000215" || sInput === "0000000000284"))
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
				else if(sInput.indexOf(aListVoucher[i]) == 0)
				{
					$(el('edtWebCode')).closest('.control-group').show();
					$('.webcodeAlwaysVisible').prop('required', true);
					matched = true;
					break;
				} else {
					$('.webcodeAlwaysVisible').prop('required', false);
				}
			}
			if(!matched)
			{
				// Check years
				if(sInput.length > 3)
				{
					var checkYear = parseInt(sInput.substring(0,4));
					if(!isNaN(parseFloat(checkYear)) && isFinite(checkYear))
					{
						if(checkYear > 2000 && checkYear < 3000)
						{
							// it is a year
							$(el('edtWebCode')).closest('.control-group').show();
						}
					}
					else
					{
						$(el('edtWebCode')).closest('.control-group').hide();
					}
				}
				else
				{
					$(el('edtWebCode')).closest('.control-group').hide();
				}
			}
		}
		else
		{
			$(el('edtWebCode')).closest('.control-group').hide();
		}
	});

	$(el('mainContainer')).on('click', '.submitSortPickupPoints', function(e)
	{
		e.preventDefault();

		var sPostalCode = $('.sortPickupPointsPostalCode').val();
		sortPickupPoints(sPostalCode);
	});

	$(el('mainContainer')).on('click', '.btnPaymentLoyalty', function(e)
	{
		e.preventDefault();

		var oBtn = $(this);

		oBtn.prop('disabled',true).addClass('loadingtrue');

		bValidForm = validateForm($('.saleCreditAmountWrapper'));

		if(bValidForm)
		{
			var oParent          = oBtn.parents("label");
			var sPaymentMethodId = oParent.find('input[name="payments"]:checked').val();
			var iAmount          = oParent.find('.amount').val();

			var oCall = addPayment(sPaymentMethodId, iAmount);
			oCall.success(function(oData)
			{
				if (oData.ErrorMessage === '')
				{
					loadQuickCheckoutPayment();
				}
				else
				{
					oBtn.prop('disabled',false).removeClass('loadingtrue');

					inlineAlert('error', oData.ErrorMessage, oData.Unhandled, $(".saleCreditAmountWrapper"), false);
				}
			});
		}
		else
		{
			oBtn.prop('disabled',false).removeClass('loadingtrue');
		}
	});

	$(el('mainContainer')).on('click', '.removePayment', function(e)
	{
		e.preventDefault();

		removePayment($(this).data('paymentId'));
	});

	$(el('mainContainer')).on('click', '#addGiftVoucher', function()
	{
		var sInputValue = $(el('edtVoucher')).val();
		var sInputWebCodeValue = $(el('edtWebCode')).val();
		var bWebcodeAlwaysVisible = ($('.webcodeAlwaysVisible').length > 0);
		sInputValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputValue.trim().replaceAll(" ","") : sInputValue;
		sInputWebCodeValue = (bRemoveSpacesFromVoucherReferenceInput) ? sInputWebCodeValue.trim().replaceAll(" ","") : sInputWebCodeValue;
		if($('#edtWebCode').is(":visible") && !bWebcodeAlwaysVisible)
		{
			if(fieldIsValid($('#edtWebCode')))
			{
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
			else
			{
				setFieldValidationState($('#edtWebCode'),'error');
			}
		}
		else
		{
			if(bWebcodeAlwaysVisible) {
				if (sInputWebCodeValue == '' && sInputValue == '') {
					setFieldValidationState($('#edtVoucher'),'error');
				} else if ($('.webcodeAlwaysVisible').prop('required') && sInputWebCodeValue == '') {
					setFieldValidationState($('#edtVoucher'),'success');
					setFieldValidationState($('#edtWebCode'),'error');
				} else {
					submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
				}
			} else {
				submitGiftVoucher(sInputValue.toUpperCase(), $(el('edtWebCode')).val().toUpperCase());
			}
		}

		return false;
	});

	$(el('mainContainer')).on('keypress','.sortPickupPointsPostalCode', function(e)
	{
		if (e.keyCode == 13)
		{
			e.preventDefault();

			var sPostalCode = $('.sortPickupPointsPostalCode').val();
			sortPickupPoints(sPostalCode);
		}
	});

	var keyupTimeoutEmailQuickCheckout;
	$(el('mainContainer')).on('keyup', '#edtEmailQuickCheckout', function() {
		var sEmail = $(this).val();

		clearTimeout(keyupTimeoutEmailQuickCheckout);

		keyupTimeoutEmailQuickCheckout = setTimeout(function() {
			var bValidEmail = validateQuickCheckoutEmail();
			if (bValidEmail) {
				var oCall = checkEmail(sEmail);
				oCall.success(function(oData)
				{
					handleCheckEmail(oData);
				});
			}
		}, 500);
	});

	// COLLAPSE
	$(el('mainContainer')).on('show','#deliveryAccordion >.accordion-group >.accordion-body', function(e)
	{
		if($(e.target).hasClass('accordion-body'))
		{
			$(this).parents('.accordion-group').addClass('activeAccordionGroup');

			if($(this).attr('id') === 'collapseCC')
			{
				var sCCShopId = $(this).find('option:selected').data('id');
				loadCCShopData(sCCShopId);
				setDeliveryDate($(this).find('.deliveryDate'));
			}
			if($(this).attr('id') === 'collapseHD')
			{
				setDeliveryDate($(this).find('.deliveryDate'));
			}
			if($(this).attr('id') === 'collapsePPbpost')
			{
				setDeliveryDate($(this).find('.deliveryDate'));
			}
			if($(this).attr('id') === 'collapsePP')
			{
				var sPickupPointId = $(this).find('input[name="PickupPointRadio"]:checked').data('id');
				loadPickupPointData(sPickupPointId);
				setDeliveryDate($(this).find('.deliveryDate'));
			}
			if (typeof $(this).data('collectmethodId') !== 'undefined' && $(this).data('collectmethodId') !== '')
			{
				if($(this).attr('id') === 'collapsePP')
				{
					var sPickupPointId = $(this).find('input[name="PickupPointRadio"]:checked').data('id');
					var sShopId        = $(this).find('input[name="PickupPointRadio"]:checked').attr('shopid');

					if(typeof sPickupPointId != "undefined" && sPickupPointId !== "" && typeof sShopId !== "undefined" && sShopId !== "")
					{
						setCollectMethodTransaction($(el("collapsePP")).data('collectmethodId'),sShopId,sPickupPointId);
					}

				}
				else if($(this).attr('id') === 'collapseCC')
				{
					var sCCShopId = $(this).find('option:selected').data('id');

					if(typeof sCCShopId !== "undefined" && sCCShopId !== "")
					{
						setCollectMethodTransaction($(el("collapseCC")).data('collectmethodId'),sCCShopId);
					}
				}
				else
				{
					setCollectMethodTransaction($(this).data('collectmethodId'));
				}

			}
		}
	});

	$(el('mainContainer')).on('hide','#deliveryAccordion >.accordion-group >.accordion-body', function(e)
	{
		if($(e.target).hasClass('accordion-body'))
		{
			$('.accordion-group').removeClass('activeAccordionGroup');
		}
	});

	// KEYPRESS
	$(el('mainContainer')).on('keypress','.inputBpostPostalcode', function(e)
	{
		if (e.keyCode == 13)
		{
			e.preventDefault();

			var sPostalCode = $('.inputBpostPostalcode').val();
			loadNearestBpostAddresses(sPostalCode);
		}
	});


	$(el('mainContainer')).on('keypress','.inputSendcloudPostalcodeSearch', function(e)
	{
		if (e.keyCode == 13)
		{
			e.preventDefault();

			var sPostalCode = $('.inputSendcloudPostalcodeSearch').val();
			var sCountryCode = $('.inputSendcloudCountry').val();
			var sCountryDescription = $('.inputSendcloudCountry').find('option:selected').html().trim();

			loadNearestSendcloudAddresses(sPostalCode,sCountryCode,sCountryDescription);
		}
	});

	// MODAL
	$(el('mainContainer')).on('hide', '#quickCheckoutInvoiceAddressOther', function()
	{
		validateAddressDefaults();
	});

	$(el('mainContainer')).on('show', '#quickCheckoutInvoiceAddressOther', function()
	{
		$('#quickCheckoutInvoiceAddressOther input[name="inputInvoiceAddress"]').parents('.radio').css("display","flex");
		$('#quickCheckoutInvoiceAddressOther input[name="inputInvoiceAddress"][value="' + $(el('inputDeliveryAddressValue')).val() + '"]').parents('.radio').css("display","none");
	});

	window.onpopstate = function(event)
	{
		if(event.state !== null && event.state.content !== null && event.state.content === "delivery")
		{
			loadQuickCheckoutDelivery();
		}
		else if(event.state !== null && event.state.content !== null && event.state.content === "payment")
		{
			history.go(-2);
		}
		else
		{
			history.back();
		}
	}

	$(el('mainContainer')).on('keyup', '.searchAddressList', function(e) {
		e.stopPropagation();
		e.preventDefault();
		var sValue = $(this).val().toLowerCase().trim();
		var sSearchStrings = sValue.split("%");
		$(".addressOtherWrapper label").each(function(j,address) {
			var foundEl = true;
			$.each(sSearchStrings, function(i, stringtoSearch) {
				if (foundEl) {
					foundEl = $(address).data('search-keywords').toLowerCase().indexOf(stringtoSearch) > -1;
				}
			});
			$(this).toggle(foundEl);
		});
	});

	if($('.sortPickupPointsPostalCode').length){
		navigator.geolocation.getCurrentPosition(parseLocationResult);
	}

	//init
	init();
});

function addPayment(sPaymentTypeId, iAmount)
{
	uAjax = '/index.cfm/transaction/ajax/addpayment';

	var sParams = '&type=' + sPaymentTypeId + '&amount=' + iAmount;
	return oCall   = callAjax("addPayment", sParams, "post");
}

function executeIdentify(bLoginCustomer,token){
	var oCall = checkEmail($(el('edtEmailQuickCheckout')).val());
	oCall.success(function(oData)
	{
		handleCheckEmail(oData);

		var bReturningCustomer = (typeof $(el('returningCustomerId')).val() !== "undefined" && $(el('returningCustomerId')).val() !== "") ? true: false;
		submitIdentification(bReturningCustomer, bLoginCustomer, token);
	});
}

function checkEmail(sEmail)
{
	uAjax = '/index.cfm/customer/ajax/checkemail';

	var sParams = '&email=' + encodeURIComponent(sEmail);
	return oCall   = callAjax("checkemail", sParams, "post");
}

function createNewAddress(oForm)
{
	uAjax = '/index.cfm/customer/ajax/updateaddress';

	var sParams = getValues(oForm);

	return oCall   = callAjax("updateaddress", sParams, "post");
}

function dateDiffInDays(sDate1, sDate2) {
	const iMsPerDay = 1000 * 60 * 60 * 24;
	// disregard time and timezone
	const sUtc1 = Date.UTC(sDate1.getFullYear(), sDate1.getMonth(), sDate1.getDate());
	const sUtc2 = Date.UTC(sDate2.getFullYear(), sDate2.getMonth(), sDate2.getDate());

	return Math.floor((sUtc2 - sUtc1) / iMsPerDay);
}

function handleCheckEmail(oData)
{
	$(".identifyWrapper").removeClass("blockedCustomer");
	if(oData.errorType === 'exists')
	{
		if(oData.data.id !== 'undefined')
		{
			$(el('returningCustomerId')).val(oData.data.id);
		}
		$(el("btnQuickCheckout")).attr("logincustomer",true);
		setReturningCustomer(true);
	}
	else
	{
		$(el('returningCustomerId')).val("");
		$(el("btnQuickCheckout")).attr("logincustomer",false);
		setReturningCustomer(false);
	}
}

function quickCheckoutAddressList(sType)
{
	uAjax = '/index.cfm/transaction/ajax/quickCheckoutAddressList?type=' + sType;

	return oCall = callAjax("quickcheckoutaddresslist", "", "post");
}

function setSelectedStateInputPickupPoint(bSelectedState)
{
	bSelectedState ? $(el('inputPickupPoint')).addClass('selectedState') : $(el('inputPickupPoint')).removeClass('selectedState')
}

function setSubmitIdentificationBtnDisabled(bEnable, oBtn)
{
	$('.btnQuickCheckoutSubmit').prop('disabled',bEnable).removeClass('disabledtrue disabledfalse').addClass('disabled'+bEnable);;

	if(typeof oBtn !== "undefined")
	{
		oBtn.addClass('loading'+bEnable);
	}
	else
	{
		$('.btnQuickCheckoutSubmit').removeClass('loadingtrue');
	}
}

function setSubmitDisabled(bEnable)
{
	$('.quickcheckoutSubmitButton').prop('disabled',bEnable).removeClass('disabledtrue disabledfalse').addClass('disabled'+bEnable);

	// disable accordion
	if(bEnable)
	{
		$('.accordion-heading .accordion-toggle').addClass('disableToggle');
	}
	else
	{
		$('.accordion-heading .accordion-toggle').removeClass('disableToggle');
	}
}

function init()
{
	var oActiveAccordionGroup = $('.activeAccordionGroup');

	if(oActiveAccordionGroup.find('.inputInvoiceRequired').length > 0)
	{
		var bChecked = oActiveAccordionGroup.find('.inputInvoiceRequired').prop('checked');
	}
	if(oActiveAccordionGroup.find('.deliveryDate').length > 0)
	{
		setDeliveryDate(oActiveAccordionGroup.find('.deliveryDate'));
	}
	if(oActiveAccordionGroup.find('#inputCCShop').length > 0)
	{
		var sCCShopId = oActiveAccordionGroup.find('#inputCCShop option:selected').data('id');
		loadCCShopData(sCCShopId);
	}
	if(oActiveAccordionGroup.find('#inputPickupPoint').length > 0)
	{
		var sPickupPointId = oActiveAccordionGroup.find('#inputPickupPoint input[name=PickupPointRadio]:checked').data('id');

		if(typeof sPickupPointId == "string" && sPickupPointId != "")
		{
			loadPickupPointData(sPickupPointId);
		}
	}
	if($('.identify').length > 0){
		$(document).trigger( "nextCheckoutStep",2);
	}
	else{
		$(document).trigger( "nextCheckoutStep",3);

		if(history.state == null)
		{
			// push state
			history.pushState({content: "delivery"}, "delivery", "");
		}
	}
}

function loadBpostOpeningHours(sId, sType)
{
	var sParams = '&id=' + sId + '&type=' + sType;
	var oCall   = callAjax("getBpostOpeningHours", sParams, "post", "/index.cfm/transaction/ajax/getBpostOpeningHours");
	oCall.success(function(oData)
	{
		if (oData.errorMessage === '')
		{
			var oNearest = $('.selectNearest[data-id="' + sId + '"]');
			oNearest.find('.selectNearestOpeningHours').html(oData.html);

			setBpostOpeningHours(oNearest,true);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function loadCCShopData(sCCShopId)
{
	if(sCCShopId !== "")
	{
		var sParams = '&shopId=' + sCCShopId;
		var oCall   = callAjax("ccloadshopinfo", sParams, "post", "/index.cfm/transaction/ajax/ccloadshopinfo");
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				$('.selectedShopData').html(oData.html)
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	else
	{
		$('.selectedShopData').html('');
	}
}

function loadForgotPassword(bToggleOn)
{
	if(bToggleOn)
	{
		$('.btnQuickCheckoutWrapper,.returningCustomer').hide();
		$('.btnQuickCheckoutForgotPasswordWrapper').show();
	}
	else
	{
		$('.btnQuickCheckoutForgotPasswordWrapper').hide();
		$('.btnQuickCheckoutWrapper,.returningCustomer').show();
	}

}

function loadNearestBpostAddresses(sPostalCode)
{
	if(sPostalCode !== "")
	{
		var sParams = '&postalCode=' + sPostalCode;
		var oCall   = callAjax("getNearestBpostAddresses", sParams, "post", "/index.cfm/transaction/ajax/getNearestBpostAddresses");
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				$('.BpostData').html(oData.html);

				if (oData.googlemap !== '')
				{
					$('.googleContainerBpost').html(oData.googlemap);

					map = new google.maps.Map(document.getElementById('googleMapBpost'),mapOptions);
					googleMapMarkers();
					$(el('googleMapBpost')).addClass('loaded');
				}
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
}

function loadNearestSendcloudAddresses(sPostalCode,sCountryCode,sCountryDescription)
{
	if(sPostalCode !== "" && sCountryCode !== "")
	{
		geoLookup(sPostalCode,sCountryDescription,handleGeolocateSendcloudLookup,sCountryCode);
	}
}

function handleGeolocateSendcloudLookup(oLookup)
{
	var sLookup = JSON.stringify(oLookup);
	var oParse  = JSON.parse(sLookup);

	oParse.results[0].geometry.viewport.south -= - 0.01;
	oParse.results[0].geometry.viewport.west -= - 0.01;
	oParse.results[0].geometry.viewport.north += + 0.01;
	oParse.results[0].geometry.viewport.east += + 0.01;

	var sParams = '&geoLocation=' + JSON.stringify(oParse);
	var oCall   = callAjax("getNearestSendcloudAddresses", sParams, "post", "/index.cfm/transaction/ajax/getNearestSendcloudAddresses");
	oCall.success(function(oData)
	{
		if (oData.errorMessage === '')
		{
			$('.sendcloudData').html(oData.html);

			if (oData.googlemap !== '')
			{
				$('.googleContainerSendcloud').html(oData.googlemap);

				var oMapoptions = {
					mapTypeId: "roadmap"
				};
				var bounds = new google.maps.LatLngBounds(
					{lat: oParse.results[0].geometry.viewport.south, lng: oParse.results[0].geometry.viewport.west},
					{lat: oParse.results[0].geometry.viewport.north, lng: oParse.results[0].geometry.viewport.east}
				);

				map = new google.maps.Map(document.getElementById('googleMapSendcloud'),oMapoptions);
				map.fitBounds(bounds);

				googleMapMarkers();
				$(el('googleMapSendcloud')).addClass('loaded');
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function parseLocationResult(geoLocationResult){
	var geoLookup = {};
	geoLookup.lat = geoLocationResult.coords.latitude;
	geoLookup.lng = geoLocationResult.coords.longitude;
	geoLookup.countryCode = sCountryCode;

	loadNearestPickupPoints(geoLookup);
}

function loadNearestPickupPoints(geoLookup)
{
	$('.inputPickupPointControls').addClass('loading');

	var sParams = '&latitude=' + geoLookup.lat
	+ '&longitude=' + geoLookup.lng + "&countryCode=" + geoLookup.countryCode;

	var oCall   = callAjax("getNearestPickupPoints", sParams, "post", "/index.cfm/transaction/ajax/getnearestpickuppoints");
	oCall.success(function(oData)
	{
		$('.inputPickupPointControls').removeClass('loading');

		if (oData.errorMessage === '')
		{
			$(el('inputPickupPoint')).html(oData.html).trigger('change');
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function loadPickupPointData(sPickupPointId)
{
	if(typeof sPickupPointId !== "undefined" && sPickupPointId !== null && sPickupPointId !== "")
	{
		var sParams = '&pickupPointId=' + sPickupPointId;
		var oCall   = callAjax("loadpickuppointdata", sParams, "post", "/index.cfm/transaction/ajax/loadpickuppointdata");
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				$('.selectedPointData').html(oData.html)
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	else
	{
		$('.selectedPointData').html('');
	}
}

function loadQuickCheckoutDelivery()
{
	var sParams = '&QCreturningCustomer=' + bReturningCustomer + '&QCloginCustomer=' + bLoginCustomer + '&QCemail=' + sEmail;
	var oCall   = callAjax("loadquickcheckoutdelivery", sParams, "post", "/index.cfm/transaction/ajax/loadquickcheckoutdelivery");
	oCall.success(function(oData)
	{
		if (oData.errorMessage === '')
		{
			setQuickCheckoutView('delivery', oData.html, oData.basket);
			$('.quickCheckoutStep4').removeClass('active');
			$('.quickCheckoutStep3').addClass('active');

			var oActiveAccordionGroup = $('.activeAccordionGroup');
			if(oActiveAccordionGroup.find('.deliveryDate').length > 0)
			{
				setDeliveryDate(oActiveAccordionGroup.find('.deliveryDate'),true);
			}
			if($.isFunction($.fn.inputmask))
			{
				formatInputs();
			}

			if(history.state !== null && history.state.content !== null && history.state.content === "payment")
			{
				// push state
				history.pushState({content:"loadDelivery"}, "", "");
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function loadQuickCheckoutPayment()
{
	var oForm   = $('.activeAccordionGroup').find('form');
	var sParams = getValues(oForm);
	var oCall   = callAjax("loadquickcheckoutpayment", sParams, "post", "/index.cfm/transaction/ajax/loadquickcheckoutpayment");
	oCall.success(function(oData)
	{
		setSubmitDisabled(false);

		if (oData.errorMessage === '')
		{
			setQuickCheckoutView('payment', oData.html, oData.basket);
			$('.quickCheckoutStep3').removeClass('active');
			$('.quickCheckoutStep4').addClass('active');

			// Select first payment type
			$(el('paymentContent')).find('.paymenttype:first').prop('checked', true).trigger('change');

			// push state
			history.pushState({content: "payment"}, "payment", "");
		}
		else
		{
			if (oData.errorType == "offline" || oData.errorType == "EInterSolveServiceErrorEmpty" || oData.errorType == "emptyTransaction") {
				return window.location = "/" + sCurrentLanguageCode + "/transaction";
			}
			var oBasket = $('.quickCheckoutWrapper').find('.quickCheckoutBasket');
			oBasket.html(oData.basketQC);
			inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $('#submitVoucherOnly,#submitQuickCheckoutBpostAddress,#submitQuickCheckoutDeliveryAddress,#submitQuickCheckoutCCShop,#submitQuickCheckoutPickupAddress'), false);

			// reset home_delivery_bike
			if(oData.errorType == "stock" && oData.totalAmountToPay !== "undefined" && $(".quickCheckoutCustomHomeDelivery").length > 0)
			{
				setCustomHdDelivery(oData.totalAmountToPay >= iQuickCheckoutCustomHdMinAmount);
			}
		}
	});
}

function loadBpostAddress(sId, sType, oEl)
{
	var sParams = '&id=' + sId + '&type=' + sType;
	var oCall   = callAjax("getBpostAddress", sParams, "post", "/index.cfm/transaction/ajax/getBpostAddress");
	oCall.success(function(oData)
	{
		if (oData.errorMessage === '')
		{
			$('.selectedBpostData').html(oData.html);

			$('.selectNearest').removeClass('selected');
			oEl.addClass('selected');

			if(typeof oData.lat !== 'undefined' && oData.lat !== '' && typeof oData.long !== 'undefined' && oData.long !== '')
			{
				map.setOptions({
					zoom: 16,
					center:
					{
						lat: parseFloat(oData.lat),
						lng: parseFloat(oData.long)
					}
				});
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function loadSendCloudServicePoint(oEl)
{
	$('.selectedSendcloudData').show();
	$('.selectedSendcloudData .sendcloudAddress .sendcloudAddressName').html('<strong>' + oEl.data('name') + '</strong>');
	$('.selectedSendcloudData .sendcloudAddress .sendcloudAddressStreet').html(oEl.data('street') + ' ' + oEl.data('housenumber'));
	$('.selectedSendcloudData .sendcloudAddress .sendcloudAddressCity').html(oEl.data('postalcode') + ' ' + oEl.data('city'));
	$('.selectedSendcloudData .inputSelectedSendcloudAddressId').val(oEl.data('id'));
	$('.selectedSendcloudData .inputSelectedSendcloudAddressName').val(oEl.data('name'));
	$('.selectedSendcloudData .inputSelectedSendcloudAddressStreet').val(oEl.data('street'));
	$('.selectedSendcloudData .inputSelectedSendcloudAddressHouseNumber').val(oEl.data('housenumber'));
	$('.selectedSendcloudData .inputSelectedSendcloudAddressPostalCode').val(oEl.data('postalcode'));
	$('.selectedSendcloudData .inputSelectedSendcloudAddressPostalCity').val(oEl.data('city'));
	$('.selectedSendcloudData .inputSelectedSendcloudAddressPostalCountry').val(oEl.data('country'));

	$('.selectNearestSendCloudServicePoint').removeClass('selected');
	oEl.addClass('selected');

	if(typeof oEl.data('latitude') !== 'undefined' && oEl.data('latitude') !== '' && typeof oEl.data('longitude') !== 'undefined' && oEl.data('longitude') !== '')
	{
		map.setOptions({
			zoom: 16,
			center:
			{
				lat: parseFloat(oEl.data('latitude')),
				lng: parseFloat(oEl.data('longitude'))
			}
		});
	}

	$(".selectNearestWrapper").animate({
		scrollTop:  $(".selectNearestWrapper").scrollTop() - $(".selectNearestWrapper").offset().top + oEl.offset().top
	}, 1000);
}

function removePayment(sPaymentId)
{
	var sParams = '&paymentId=' + sPaymentId;
	var oCall   = callAjax("removePayment", sParams, "post", "/index.cfm/transaction/ajax");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			if($(".quickcheckoutDelivery").length > 0)
			{
				loadQuickCheckoutDelivery();
			}
			else if($(".quickcheckoutPayment").length > 0)
			{
				loadQuickCheckoutPayment();
			}
			else
			{
				location.reload(true);
			}
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function reTriggerChosenAddress()
{
	if($(el('inputDeliveryAddressValue')).val() !== "default")
	{
		$('.addressOtherWrapper input[name="inputDeliveryAddress"][value="' + $(el('inputDeliveryAddressValue')).val() + '"]').trigger('change').prop("checked", true);
	}
}

function resolveAddressConflict(oFrm)
{
	uAjax = '/index.cfm/transaction/ajax/resolveaddressconflict';

	var sParams = getValues(oFrm);

	return callAjax("resolveAddressConflict", sParams, "post");
}

function saveBpostAddress(oEl, sCollectMethod)
{
	uAjax = "/index.cfm/transaction/ajax/updatedeliveryaddress?edtDeliveryAddressType=bpost&bpostpickup=true";
	var sParams = '&edtDeliveryAddress=' + oEl.data('id') + '&type=' + oEl.data('type') + '&collectMethod=' + sCollectMethod + "&shopId=" + oEl.data('id');

	// if anonymous
	if(bReturningCustomer && !bLoginCustomer)
	{
		sParams += setDeliveryName($(el('frmDeliveryBpost')));
	}

	return oCall = callAjax("updateDeliveryAddress", sParams, "post");
}

function saveSendcloudAddress(oEl, sCollectMethod)
{
	uAjax = "/index.cfm/transaction/ajax/updatedeliveryaddress?edtDeliveryAddressType=sendcloud&sendcloud=true";
	var sParams = '&edtDeliveryAddress=' + oEl.data('id') + '&collectMethod=' + sCollectMethod + '&name=' + oEl.data('name') + '&street=' + oEl.data('street') + '&housenumber=' + oEl.data('housenumber') + '&postalcode=' + oEl.data('postalcode') + '&city=' + oEl.data('city') + '&country=' + oEl.data('country');

	// if anonymous
	if(bReturningCustomer && !bLoginCustomer)
	{
		sParams += setDeliveryName($(el('frmDeliveryBpost')));
	}

	return oCall = callAjax("updateDeliveryAddress", sParams, "post");
}

function saveCCShop(oEl, sCollectMethodId)
{
	uAjax = "/index.cfm/transaction/ajax/updatecollectmethodtransaction";
	var sParams = "&collectMethodId=" + sCollectMethodId + "&shopId=" + oEl.data('id') + "&resetDispatchMethod=1";

	return oCall = callAjax("updateCollectMethodTransaction", sParams, "post");
}

function savePickupPoint(oEl, sCollectMethod)
{
	uAjax = "/index.cfm/transaction/ajax/updatedeliveryaddress?edtDeliveryAddressType=pickuppoint&pickuppointcheckout=true";
	var sParams = '&edtDeliveryAddress=' + oEl.attr('pickupId') + '&shopId=' + oEl.attr('shopId') + '&collectMethod=' + sCollectMethod;

	// if anonymous
	if(bReturningCustomer && !bLoginCustomer)
	{
		sParams += setDeliveryName($(el('frmDeliveryPickup')));
	}

	return oCall = callAjax("updateDeliveryAddress", sParams, "post");
}

/*
function selectPickupPoint(oEl)
{
	if(!bReturningCustomer)
	{
		oCall = updateInvoiceAddress();
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				oCall = savePickupPoint(oEl);
				oCall.success(function(oData)
				{
					if (oData.ErrorType == '')
					{
						loadQuickCheckoutPayment();
					}
					else
					{
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
					}
				});
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	else
	{
		oCall = savePickupPoint(oEl);
		oCall.success(function(oData)
		{
			if (oData.ErrorType == '')
			{
				loadQuickCheckoutPayment();
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
}*/

function sendPasswordReset()
{
	uAjax = "/index.cfm/customer/ajax/sendpassword";

	var sParams = '&email=' + $(el('edtEmailQuickCheckout')).val();
	var oCall   = callAjax("sendpassword", sParams, "post");
	oCall.success(function(oData)
	{


		if (oData.errorType == '')
		{
			$(".unToggleForgotPasswordBtn").trigger("click");
			showAlert('warning', tPasswordSent, false, 3000);
		}
		else
		{
			$(el('btnQuickCheckoutForgotPassword')).prop("disabled",false);

			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function setDefaultDeliveryDate(oEl,minDate)
{
	var oDeliveryDate = new Date();

	if(typeof minDate !== 'undefined')
	{
		oDeliveryDate.setDate(oDeliveryDate.getDate() + minDate);

		// check if default is disabled - +1 if default is disabled
		var foundEnabledDate = false;
		while (!foundEnabledDate)
		{
			if(checkDisableDays(oDeliveryDate)[0])
			{
				foundEnabledDate = true;
			}
			else
			{
				oDeliveryDate.setDate(oDeliveryDate.getDate() + 1);
			}
		}
	}

	var aList = [];
	if(typeof sDisableSpecificDays !== 'undefined' && sDisableSpecificDays !== '')
	{
		var daysList = sDisableSpecificDays.toString().split(',');
		daysList = daysList.map(String);
		aList = daysList;
	}

	if(aList.length > 0)
	{
		if(aList.find(function(listDate){return oDeliveryDate.getDay().toString() == listDate}))
		{
			var matchedDate = false;
			while (!matchedDate)
			{
				oDeliveryDate.setDate(oDeliveryDate.getDate() + 1);
				if(typeof aList.find(function(listDate){return oDeliveryDate.getDay().toString() == listDate}) == 'undefined')
				{
					matchedDate = true;
				}
			}
		}
		if(oEl.attr('type') == 'hidden')
		{
			oEl.val(oDeliveryDate.getDate() + '-' + (oDeliveryDate.getMonth() + 1) + '-' + oDeliveryDate.getFullYear());
		}
		else
		{
			oEl.datepicker('setDate', oDeliveryDate);
		}
	}
}

function setDeliveryDate(oEl, bPreventReset)
{
	// Delivery address datepicker
	var minDate = (typeof sMinDate !== 'undefined' && sMinDate !== "") ? parseInt(sMinDate) : 2;
	// Check to add extra days
	if (typeof addDays !== "undefined" && parseFloat(addDays) > 0) {
		minDate += parseFloat(addDays);
	};

	var bResetDate = false;

	// Prevent next day delivery select after 15h
	var oDeliveryDate = new Date();
	if(minDate == 1 && oDeliveryDate.getHours() >= iNextDayDeliveryCutOff)
	{
		minDate++;
		bResetDate = true;
		oDeliveryDate.setDate(oDeliveryDate.getDate() + minDate);

		var bNextDatePlusOneIsEnabled = checkDisableDays(oDeliveryDate)[0];
		var foundEnabledDate = false;
		while (!foundEnabledDate)
		{
			if(checkDisableDays(oDeliveryDate)[0])
			{
				foundEnabledDate = true;

				if(!bNextDatePlusOneIsEnabled)
				{
					minDate += 1;
				}
			}
			else
			{
				minDate++;
				oDeliveryDate.setDate(oDeliveryDate.getDate() + minDate);
			}
		}
	}

	oEl.datepicker(
		{
			dateFormat: "dd-mm-yy",
			minDate: minDate,
			beforeShowDay: checkDisableDays
		}
	);

	if(typeof bPreventReset === 'undefined' && (oEl.datepicker('getDate') === null || isPastDate(oEl.datepicker('getDate')) || bResetDate))
	{
		setDefaultDeliveryDate(oEl,minDate);
	}
}

function checkDisableDays(date)
{
	var aList = [];
	if(typeof sDisableSpecificDays !== 'undefined' && sDisableSpecificDays !== '')
	{
		var daysList = sDisableSpecificDays.toString().split(',');
		daysList = daysList.map(String);
		aList = daysList;
	}

	var filterDay = date.getDate().toString() + '/' + date.getMonth().toString();

	var aExcludedDates = [];
	if (!sExcludeDatepickerDays) {
		sExcludeDatepickerDays = "2512,0101";
	}

	// Format to JS dates
	sExcludeDatepickerDays.toString().split(",").forEach(function(date){
		var newDate = parseInt(date.substr(0, 2)).toString() + "/" + (parseInt(date.substr(2)) - 1).toString();
		aExcludedDates.push(newDate);
	});

	if ($.inArray(filterDay, aExcludedDates) > -1)
	{
		return [false];
	}

	if(aList.find(function(listDate){
		return date.getDay().toString() == listDate
	}))
	{
		return [ false,"",""];
	}
	else
	{
		return [ true, "", ""];
	}
	var beforeShowDay = (bDisableWeekends) ? $.datepicker.noWeekends : null;
}

function setInvoice(bInvoice)
{
	uAjax = "/index.cfm/transaction/ajax/setinvoice";

	var sParams = '&invoice=' + bInvoice;
	var oCall   = callAjax("setinvoice", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType !== '')
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function saveNewAddress(callbackFunction)
{
	if($('.addressNew').is(':visible') && $(el('inputSaveNewAddress')).prop('checked'))
	{
		uAjax = '/index.cfm/customer/ajax/updateaddress';

		var sParams = getValues($(el('frmDeliveryHd')));
		var oCall   = callAjax("updateaddress", sParams, "post");
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				callbackFunction(loadQuickCheckoutPayment);
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
	else
	{
		callbackFunction(loadQuickCheckoutPayment);
	}
}

function setQuickCheckoutView(sView, oHtml, oBasketHtml)
{
	var oBasket  = $('.quickCheckoutWrapper').find('.quickCheckoutBasket');
	var oContent = $('.quickCheckoutWrapper').find('.quickCheckoutContent');
	oContent.addClass('loading');

	switch(sView)
	{
		case 'delivery':
			$(document).trigger( "nextCheckoutStep",3);
			oContent.removeClass('loading');
			oBasket.html(oBasketHtml);
			oContent.html(oHtml);

			break;
		case 'payment':
			$(document).trigger( "nextCheckoutStep",4);
			oBasket.html(oBasketHtml);
			oContent.removeClass('loading');
			oContent.html(oHtml);
			scrollToElement($(el('paymentContent')));

			break;
		default:
			oContent.removeClass('loading');
	}
}

function setReturningCustomer(bExists)
{
	if(bExists)
	{
		$('.returningCustomer,.btnQuickCheckoutWrapperNoLogin').show();
		$(el('btnQuickCheckout')).text(sQuickCheckoutBtnAndLogin);

		if(bCeraOnly)
		{
			$(el('btnQuickCheckout')).hide();
		}
	}
	else
	{
		$('.returningCustomer,.btnQuickCheckoutWrapperNoLogin').hide();
		$(el('btnQuickCheckout')).text(sQuickCheckoutBtn);

		if(bCeraOnly)
		{
			$(el('btnQuickCheckout')).show();
		}
	}
}

function sortPickupPoints(sPostalCode)
{
	var sLookupCountry     = sCountryCode;
	var sLookupCountryCode = sCountryCode;

	if(sPostalCode != '')
	{
		geoLookup(sPostalCode,sLookupCountry,loadNearestPickupPoints,sLookupCountryCode);
	}
}

function submitGiftVoucher(sGiftVoucher, sWebCode)
{
	if($.trim(sWebCode) === '')
	{
		sWebCode = '000';
	}
	var sParams = '&giftvoucher=' + encodeURIComponent(sGiftVoucher) + '&webcode=' + sWebCode;
	var oCall   = callAjax("addGiftVoucher", sParams, "post", "/index.cfm/transaction/ajax");
	oCall.success(function(oData)
	{
		if(oData.errorType === '')
		{
			loadQuickCheckoutPayment();
		}
		else
		{
			if(oData.errorType === 'EVoucherInvalidWebcode')
			{
				inlineAlert('error', tInvalidWebcode, oData.errorUnhandled, $(el('addGiftVoucher')), false);
			}
			else if(oData.errorType === 'EVoucherCannotBeValidatedWithoutWebCode')
			{
				inlineAlert('error', tEmptyWebcode, oData.errorUnhandled, $(el('addGiftVoucher')), false);
			}
			else
			{
				inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el('addGiftVoucher')), false);
			}
		}
	});
}

function submitIdentification(bReturningCustomer,bLoginCustomer,token)
{

	var bValidEmail = validateQuickCheckoutEmail();

	if(bValidEmail)
	{
		uAjax = "/index.cfm/transaction/ajax/identify";
		var bRememberLogin = $(el('toggleRememberLogin')).is(':checked');
		var sCustomerId    = $(el('returningCustomerId')).val();
		var sEmail         = encodeURIComponent($(el('edtEmailQuickCheckout')).val());
		var sPassword      = encodeURIComponent($(el('edtPasswordQuickCheckout')).val());
		var sToken		   = encodeURIComponent(token);
		var sParams        = '&email=' + sEmail + '&password=' + sPassword + '&remember=' + bRememberLogin + '&loginCustomer=' + bLoginCustomer + '&returningCustomer=' + bReturningCustomer + '&customerId=' + sCustomerId + '&grecaptchatoken=' + token;
		var oCall          = callAjax("identify", sParams, "post");
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				window.location = oData.redirectURL;
			}
			else if (oData.errorMessage === 'blocked')
			{
				$(".identifyWrapper").addClass("blockedCustomer");
				setSubmitIdentificationBtnDisabled(false);

				inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el('btnQuickCheckout')), false);
			}
			else if(oData.errorType === 'multiple')
			{
				clearErrors();

				$(el("contactsPopup")).remove();
				$(el("mainContainer")).append(oData.html);
				$(el("contactsPopup")).modal();

				centerPopups();
			}
			else
			{
				setSubmitIdentificationBtnDisabled(false);

				inlineAlert('error', oData.errorMessage, oData.errorUnhandled, $(el('btnQuickCheckout')), false);
			}
		});
	}
	else
	{
		setSubmitIdentificationBtnDisabled(false);
	}
}

function submitQuickCheckoutCCShop(oEl,sCollectMethodId)
{
	var oForm = $(el('frmDeliveryCC'));
	var bValidForm       = validateQuickCheckoutCCShop(oForm, true);

	if(bValidForm && (!bReturningCustomer || (bReturningCustomer && bLoginCustomer)))
	{
		oCall = updateInvoiceAddress(oForm);
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				oCall = saveCCShop(oEl,sCollectMethodId);
				oCall.success(function(oData)
				{
					if (oData.ErrorType == '')
					{
						saveDeliveryDate(loadQuickCheckoutPayment);
					}
					else
					{
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
						setSubmitDisabled(false);
					}
				});
			}
			else if(oData.errorType === 'expired')
			{
				location.reload(true);
			}
			else if(oData.errorType === 'invalidEmail')
			{
				window.location = '/' + sCurrentLanguageCode + '/transaction/checkout';
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
	else if(bValidForm && bReturningCustomer && !bLoginCustomer)
	{
		oCall = saveCCShop(oEl,sCollectMethodId);
		oCall.success(function(oData)
		{
			if (oData.ErrorType == '')
			{
				saveDeliveryDate(loadQuickCheckoutPayment);
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
}

function submitQuickCheckoutDeliveryAddress(sMissingParams,sCollectMethod)
{
	var oForm = $(el('frmDeliveryHd'));
	var bValidForm = validateQuickCheckoutDeliveryAddress(oForm,true);

	if(bValidForm && (!bReturningCustomer || (bReturningCustomer && bLoginCustomer)))
	{
		var oCall =  updateInvoiceAddress(oForm);
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				saveDeliveryAddress(saveNewAddress,sMissingParams,sCollectMethod);
			}
			else if(oData.errorType === 'expired')
			{
				location.reload(true);
			}
			else if(oData.errorType === 'invalidEmail')
			{
				window.location = '/' + sCurrentLanguageCode + '/transaction/checkout';
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
	else if(bValidForm && bReturningCustomer && !bLoginCustomer)
	{
		saveDeliveryAddress(saveNewAddress,sMissingParams,sCollectMethod);
	}
}

function submitQuickCheckoutPickupAddress(oEl,sCollectMethod)
{
	var oForm = $(el('frmDeliveryPickup'));
	var bValidForm = validateQuickCheckoutPickupAddress(oForm,true);

	if(bValidForm && (!bReturningCustomer || (bReturningCustomer && bLoginCustomer)))
	{
		oCall = updateInvoiceAddress(oForm);
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				oCall = savePickupPoint(oEl,sCollectMethod);
				oCall.success(function(oData)
				{
					if (oData.ErrorType === '' || oData.errorType === '')
					{
						saveDeliveryDate(loadQuickCheckoutPayment);
					}
					else
					{
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
						setSubmitDisabled(false);
					}
				});
			}
			else if(oData.errorType === 'expired')
			{
				location.reload(true);
			}
			else if(oData.errorType === 'invalidEmail')
			{
				window.location = '/' + sCurrentLanguageCode + '/transaction/checkout';
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
	else if(bValidForm && bReturningCustomer && !bLoginCustomer)
	{
		oCall = savePickupPoint(oEl,sCollectMethod);
		oCall.success(function(oData)
		{
			if (oData.ErrorType === '' || oData.errorType === '')
			{
				saveDeliveryDate(loadQuickCheckoutPayment);
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
}

function submitQuickCheckoutBpostAddress(oEl,sCollectMethod)
{
	var oForm      = $(el('frmDeliveryBpost'));
	var bValidForm = validateQuickCheckoutBpostAddress(oForm, true);

	if(bValidForm && (!bReturningCustomer || (bReturningCustomer && bLoginCustomer)))
	{
		oCall = updateInvoiceAddress(oForm);
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				oCall = saveBpostAddress(oEl,sCollectMethod);
				oCall.success(function(oData)
				{
					if (oData.ErrorType === '' || oData.errorType === '')
					{
						saveDeliveryDate(loadQuickCheckoutPayment);
					}
					else
					{
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
						setSubmitDisabled(false);
					}
				});
			}
			else if(oData.errorType === 'expired')
			{
				location.reload(true);
			}
			else if(oData.errorType === 'invalidEmail')
			{
				window.location = '/' + sCurrentLanguageCode + '/transaction/checkout';
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
	else if(bValidForm && bReturningCustomer && !bLoginCustomer)
	{
		oCall = saveBpostAddress(oEl,sCollectMethod);
		oCall.success(function(oData)
		{
			if (oData.ErrorType === '' || oData.errorType === '')
			{
				saveDeliveryDate(loadQuickCheckoutPayment);
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
}

function submitQuickCheckoutSendcloudAddress(oEl,sCollectMethod,sMissingCustomerData)
{
	var oForm      = $(el('frmDeliverySendcloud'));
	var bValidForm = validateQuickCheckoutSendcloudAddress(oForm, true);

	if(bValidForm && (!bReturningCustomer || (bReturningCustomer && bLoginCustomer)))
	{
		oCall = updateInvoiceAddress(oForm,sMissingCustomerData);
		oCall.success(function(oData)
		{
			if (oData.errorMessage === '')
			{
				$(el('customerAddressEmptyFields')).modal("hide");

				oCall = saveSendcloudAddress(oEl,sCollectMethod);
				oCall.success(function(oData)
				{
					if (oData.ErrorType === '' || oData.errorType === '')
					{
						saveDeliveryDate(loadQuickCheckoutPayment);
					}
					else
					{
						showAlert('error', oData.errorMessage, oData.errorUnhandled);
						setSubmitDisabled(false);
					}
				});
			}
			else if(oData.errorType === 'expired')
			{
				location.reload(true);
			}
			else if(oData.errorType === 'invalidEmail')
			{
				window.location = '/' + sCurrentLanguageCode + '/transaction/checkout';
			}
			else if(oData.errorType === 'invalidCustomerAddress')
			{
				var oModal = $(el('customerAddressEmptyFields'));

				// set collectmethod
				oModal.find('#saveCustomerAddressEmptyFields').data('collectMethod', sCollectMethod);

				oModal.modal('show');

				setSubmitDisabled(false);
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);

				$(el('customerAddressEmptyFields')).modal("hide");
			}
		});
	}
	else if(bValidForm && bReturningCustomer && !bLoginCustomer)
	{
		oCall = saveSendcloudAddress(oEl,sCollectMethod);
		oCall.success(function(oData)
		{
			if (oData.ErrorType === '' || oData.errorType === '')
			{
				saveDeliveryDate(loadQuickCheckoutPayment);
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
}

function saveDeliveryAddress(callbackFunction,sMissingParams,sCollectMethod)
{
	uAjax   = "/index.cfm/transaction/ajax/updatedeliveryaddress?edtDeliveryAddressType=hd";
	var sParams = getValues($(el('frmDeliveryHd'))) + '&collectMethod=' + sCollectMethod;
	sParams += setDeliveryName($(el('frmDeliveryHd')));

	if(typeof sMissingParams !== "undefined" && sMissingParams !== "")
	{
		sParams += sMissingParams;
	}

	var oCall   = callAjax("updatedeliveryaddress", sParams, "post");
	oCall.success(function(oData)
	{
		if (oData.errorType === '' || oData.ErrorType === '')
		{
			callbackFunction(saveDeliveryDate);
		}
		else if(oData.errorType === 'emptyFields')
		{
			var oModal           = $(el('deliveryAddressEmptyFields'));
			var oDeliveryAddress = JSON.parse(oData.deliveryAddress);

			if($.trim(oDeliveryAddress.address)      === '') oModal.find('.address').show();
			if($.trim(oDeliveryAddress.city)         === '') oModal.find('.city').show();
			if($.trim(oDeliveryAddress.deliveryName) === '') oModal.find('.deliveryName').show();
			if($.trim(oDeliveryAddress.edtCountry)   === '' || oDeliveryAddress.edtCountry === 'null') oModal.find('.country').show();
			if($.trim(oDeliveryAddress.houseNumber)  === '') oModal.find('.houseNumber').show();
			if($.trim(oDeliveryAddress.postalCode)   === '') oModal.find('.postalCode').show();

			// set collectmethod
			oModal.find('#saveDeliveryAddressEmptyFields').data('collectMethod', sCollectMethod);

			oModal.modal('show');

			setSubmitDisabled(false);
		}
		else if(oData.errorType === "deliveryAddressData")
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			setSubmitDisabled(false);

			$(el('frmDeliveryHd')).find(".customerAddressNewBtn").trigger("click");
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
			setSubmitDisabled(false);
		}
	});
}

function saveDeliveryDate(callbackFunction)
{
	var oForm = $('.activeAccordionGroup').find('form');
	if(oForm.find('.deliveryDate').length > 0 && oForm.find('.deliveryDate').val() !== '' && !oForm.find('.deliveryDate').prop('disabled'))
	{
		// save delivery date
		var deliveryDate = oForm.find('.deliveryDate').val();
		uAjax     = "/index.cfm/transaction/ajax/updatedeliverydate?date=" + deliveryDate;
		var oCall = callAjax('updatedeliverydate', '', 'POST');
		oCall.success(function(oData)
		{
			if (oData.ErrorMessage === '')
			{
				callbackFunction();
			}
			else
			{
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
				setSubmitDisabled(false);
			}
		});
	}
	else
	{
		callbackFunction();
	}
}

function setCollectMethodTransaction(collectMethodId, sShopId, sPickupPointId)
{
	$('.quickCheckoutWrapper').find('.quickCheckoutBasket .delivery span').html('<i class="fa fa-spinner fa-spin"></i></div>');

	uAjax = "/index.cfm/transaction/ajax/updatecollectmethodtransaction";
	var sParams = "&collectMethodId=" + collectMethodId;

	if(typeof sShopId !== "undefined") sParams += "&shopId=" + sShopId;
	if(typeof sPickupPointId !== "undefined") sParams += "&pickupPointId=" + sPickupPointId;

	var oCall = callAjax("updateCollectMethodTransaction", sParams, "post");
	oCall.success(function(oData)
	{
		if(oData.ErrorMessage === '')
		{
			var oBasket  = $('.quickCheckoutWrapper').find('.quickCheckoutBasket');
			oBasket.html(oData.basketQC);
		}
		else
		{
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}
	});
}

function setCustomHdDelivery(bShow)
{
	if(bShow)
	{
		$('.quickCheckoutCustomHomeDelivery').show();
		$('.customHd').prop("disabled",false);
	}
	else
	{
		$('.quickCheckoutCustomHomeDelivery').hide();
		$('.customHd').prop("disabled",true);
	}
}
function setBpostOpeningHours(oEl, bOpen)
{
	if(bOpen)
	{
		oEl.find('.BpostOpeningHours').hide();
	}
	else
	{
		oEl.find('.selectNearestOpeningHours').empty();
		oEl.find('.BpostOpeningHours').show();
	}
}

function setDeliveryName(oFrm)
{
	var sDeliveryName = '';
	if(oFrm.find('.inputAnoFirstname').length > 0 && oFrm.find('.inputAnoFirstname').val() !== '')
	{
		sDeliveryName += '&edtAnoFirstname=' + encodeURIComponent(oFrm.find('.inputAnoFirstname').val());
	}

	if(oFrm.find('.inputAnoLastname').length > 0 && oFrm.find('.inputAnoLastname').val() !== '')
	{
		sDeliveryName += '&edtAnoLastname=' + encodeURIComponent(oFrm.find('.inputAnoLastname').val());
	}

	if(oFrm.find('.inputAnoFirstname').length > 0 && oFrm.find('.inputAnoFirstname').val() !== '' && oFrm.find('.inputAnoLastname').length > 0 && oFrm.find('.inputAnoLastname').val() !== '')
	{
		sDeliveryName += '&edtDeliveryName=' + encodeURIComponent(oFrm.find('.inputAnoFirstname').val() + ' ' + oFrm.find('.inputAnoLastname').val());
	}

	return sDeliveryName;
}

function setSubmitButtonStatus(oBtn,bStatus)
{
	if(bStatus)
	{
		oBtn.removeClass('frmInvalid').addClass('frmValid');
	}
	else
	{
		oBtn.removeClass('frmValid').addClass('frmInvalid');

		setSubmitDisabled(bStatus);
	}
}

function setInitValidation(oEl)
{
	oEl.data('initValidation',true);
}

function handleQuickCheckoutSendcloudAddressSubmit(sCollectMethod,sMissingCustomerData)
{
	setSubmitDisabled(true);

	if($('.sendcloudAddressSelected').is(':visible'))
	{
		var oSelectedOption = $('.sendcloudAddressSelected .sendcloudAddressSelectedData');
	}
	else
	{
		var oSelectedOption = $('.sendcloudData .selected');
	}

	if(oSelectedOption.length > 0)
	{
		submitQuickCheckoutSendcloudAddress(oSelectedOption,sCollectMethod,sMissingCustomerData);
	}
	else
	{
		inlineAlert('error', sWarningSelectPickup, false, $('.selectedSendcloudData'));
		setSubmitDisabled(false);
	}
}

function validateQuickCheckoutEmail()
{
	var oFrm       = $(el('frmQuickCheckout'));
	var bValidForm = validateForm(oFrm);

	setSubmitButtonStatus($(el('btnQuickCheckout')),bValidForm);

	if(!bValidForm && !fieldIsValid($(el('edtEmailQuickCheckout'))))
	{
		setReturningCustomer(false);
	}

	return bValidForm;
}

function updateAddressDefault(type,id,isMainAddress)
{
	uAjax = '/index.cfm/customer/ajax/updateAddressDefault';

	var sParams = '&type=' + type + '&id=' + id + '&isMainAddress=' + isMainAddress;
	return oCall = callAjax("updateAddressDefault", sParams, "post");
}

function updateInvoiceAddress(oFrm,sMissingCustomerData)
{
	uAjax = '/index.cfm/transaction/ajax/updateinvoiceaddress';

	var sParams = getValues(oFrm);
	sParams += '&QCreturningCustomer=' + bReturningCustomer + '&QCloginCustomer=' + bLoginCustomer + '&QCemail=' + sEmail;

	if(typeof sMissingCustomerData !== "undefined" && sMissingCustomerData !== "")
	{
		sParams += sMissingCustomerData;
	}

	if(!bReturningCustomer)
	{
		sParams += '&newCustomer=true';
	}
	if(oFrm.attr("id") === "frmDeliverySendcloud")
	{
		sParams += '&setSendcloudCustomerData=true';
	}
	return callAjax("updateInvoiceAddress", sParams, "post");
}

function validateAddressDefaults()
{
	if($(el('inputDeliveryAddressValue')).val() == $('.inputInvoiceAddressValue').val())
	{
		$('.inputInvoiceAddressEqualsDeliveryAddress').prop('checked', true);
	}
	else
	{

		$('.inputInvoiceAddressEqualsDeliveryAddress').prop('checked', false);
	}
}

function validateQuickCheckoutBpostAddress(oEl,bValidateTerms)
{
	var bValidForm = (bValidateTerms)?validateQuickCheckoutTerms(oEl):true;
	if(bValidForm && $('.privacyconditionsTerms').length > 0 && bValidateTerms){
		bValidForm = validatePrivacyConditionsTerms(oEl);
	}
	if(bValidForm)
	{
		bValidForm = validateForm(oEl);
	}

	setSubmitButtonStatus($(el('submitQuickCheckoutBpostAddress')),bValidForm);

	return bValidForm;
}

function validateQuickCheckoutSendcloudAddress(oEl,bValidateTerms)
{
	var bValidForm = (bValidateTerms)?validateQuickCheckoutTerms(oEl):true;
	if(bValidForm && $('.privacyconditionsTerms').length > 0 && bValidateTerms){
		bValidForm = validatePrivacyConditionsTerms(oEl);
	}
	if(bValidForm)
	{
		bValidForm = validateForm(oEl);
	}

	setSubmitButtonStatus($(el('submitQuickCheckoutSendcloudAddress')),bValidForm);

	return bValidForm;
}

function validateQuickCheckoutCCShop(oEl,bValidateTerms)
{
	var bValidForm = (bValidateTerms)?validateQuickCheckoutTerms(oEl):true;
	if(bValidForm && $('.privacyconditionsTerms').length > 0 && bValidateTerms){
		bValidForm = validatePrivacyConditionsTerms(oEl);
	}
	if(bValidForm)
	{
		bValidForm = validateForm(oEl);
	}

	setSubmitButtonStatus($(el('submitQuickCheckoutCCShop')),bValidForm);

	return bValidForm;
}

function validateQuickCheckoutPickupAddress(oEl,bValidateTerms)
{
	var bValidForm = (bValidateTerms)?validateQuickCheckoutTerms(oEl):true;
	if(bValidForm && $('.privacyconditionsTerms').length > 0 && bValidateTerms){
		bValidForm = validatePrivacyConditionsTerms(oEl);
	}
	if(bValidForm)
	{
		bValidForm = validateForm(oEl);
	}

	setSubmitButtonStatus($(el('submitQuickCheckoutPickupAddress')),bValidForm);

	return bValidForm;
}

function validateQuickCheckoutDeliveryAddress(oEl,bValidateTerms)
{
	var bValidForm = (bValidateTerms)?validateQuickCheckoutTerms(oEl):true;
	if(bValidForm && $('.privacyconditionsTerms').length > 0 && bValidateTerms){
		bValidForm = validatePrivacyConditionsTerms(oEl);
	}
	if(bValidForm)
	{
		bValidForm = validateForm(oEl);
	}

	setSubmitButtonStatus($(el('submitQuickCheckoutDeliveryAddress')),bValidForm);

	return bValidForm;
}

function validateQuickCheckoutDeliveryAddressVsInvoiceAddress(oForm)
{
	var bValidAddresses = true;

	if($(el('inputDeliveryAddressValue')).val() == "default")
	{
		if(typeof oForm.find('.originalCountry').val() !== 'undefined' && oForm.find('.originalCountry').val() !== oForm.find("select[name*='inputInvoiceCountry']" ).val()) return false;
		if(typeof oForm.find('.originalCompany').val() !== 'undefined' && oForm.find('.originalCompany').val() !== oForm.find("input[name*='inputInvoiceCompany']" ).val()) return false;
		if(typeof oForm.find('.originalAddress').val() !== 'undefined' && oForm.find('.originalAddress').val() !== oForm.find("input[name*='inputInvoiceStreet']" ).val()) return false;
		if(typeof oForm.find('.originalHousenumber').val() !== 'undefined' && oForm.find('.originalHousenumber').val() !== oForm.find("input[name*='inputInvoiceHousenumber']" ).val()) return false;
		if(typeof oForm.find('.originalBox').val() !== 'undefined' && oForm.find('.originalBox').val() !== oForm.find("input[name*='inputInvoiceBox']" ).val()) return false;
		if(typeof oForm.find('.originalPostalcode').val() !== 'undefined' && oForm.find('.originalPostalcode').val() !== oForm.find("input[name*='inputInvoicePostalcode']" ).val()) return false;
		if(typeof oForm.find('.originalCity').val() !== 'undefined' && oForm.find('.originalCity').val() !== oForm.find("input[name*='inputInvoiceCity']" ).val()) return false;
	}

	return bValidAddresses;
}

function validateQuickCheckoutTerms(oForm)
{
	var bAgree = true;
	var oTerms = $(oForm).find('.termsandconditions');
	oTerms.parents('.quickCheckoutTerms').siblings('.inlineAlert').remove();
	if(!$(oTerms).is(':checked'))
	{
		var oQuickCheckoutTerms = oTerms.parents('.quickCheckoutTerms');
		inlineAlert('error', tAgreeTC, null, oQuickCheckoutTerms);
		oTerms.parents('.control-group').addClass('error');

		bAgree = false;
	}

	return bAgree;
}


function validatePrivacyConditionsTerms(oForm)
{
	var bAgree = true;
	var oPrivacy = $(oForm).find('.privacyconditions');
	oPrivacy.parents('.privacyconditionsTerms').siblings('.inlineAlert').remove();
	if(!$(oPrivacy).is(':checked'))
	{
		var oPrivacyconditionsTerms = oPrivacy.parents('.privacyconditionsTerms');
		inlineAlert('error', tAgreeTC, null, oPrivacyconditionsTerms);
		oPrivacy.parents('.control-group').addClass('error');

		bAgree = false;
	}

	return bAgree;
}

function validateQuickCheckoutVoucherOnly(oEl,bValidateTerms)
{
	var bValidForm = (bValidateTerms)?validateQuickCheckoutTerms(oEl):true;
	if(bValidForm && $('.privacyconditionsTerms').length > 0 && bValidateTerms){
		bValidForm = validatePrivacyConditionsTerms(oEl);
	}
	if(bValidForm)
	{
		bValidForm = validateForm(oEl);
	}

	setSubmitButtonStatus($(el('submitVoucherOnly')),bValidForm);

	return bValidForm;
}